import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-221" data-mp="3041vsg1w7mbm">
      <Header data-id="element-222" data-mp="306ejzay8usx4" />
      <main className="flex-1" data-id="element-223" data-mp="353ddpsdzwxus">
        <Outlet data-id="element-224" data-mp="3546ac0j8q6z7" />
      </main>
      <Footer data-id="element-225" data-mp="352v7c2xmd395" />
    </div>;
}